import React, { Component } from 'react';

interface IState {
    error: boolean
}

class ErrorBoundary extends Component {
    state = {
        error: false
    }

    componentDidCatch() {
        this.setState({
            error: true
        })
    }
    
    render() {
        let FallBackUI
        if(this.state.error)
            FallBackUI = React.Children.map(this.props.children, child => {
                return React.cloneElement(child as any, {showBot: true})
            })
        return (
            this.state.error ? {FallBackUI}: this.props.children
        )
    }
}

export default ErrorBoundary;